export const formatDateToISO = (date) =>
    date.split('/').reverse().map((v, i) => i > 0 ? v.padStart(2, '0') : v).join('-');
  